// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CreateTaskPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-createtaskpage" */ "./CreateTaskPage")).then((bundle)=>{
        return {
            default: bundle.CreateTaskPage
        };
    });
export const LazyCreateTaskPage = /*#__PURE__*/ lazy(CreateTaskPageLazyLoader);
